import React, {useReducer, useState} from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {SIDEBAR_NAVIGATION_BUTTONS} from "../../../../../constants";
import AllFeaturesChecker from "../../../../../../visComponents/allFeaturesChecker";
import SqftNavEdgesFeature from "./SqftNavEdgesFeature";
import {getEdgeFeatureGroup, getEdgeFeatures} from "../../../../../helpers/shapeHelper";
import SqftNavEdgesMiteredButton from "./SqftNavEdgesMiteredButton";
import {getMiterEdgeFeature} from "../../../../../helpers/featureHelper";

const SqftNavEdges = (props) => {
  // other popups, modals and so on
  const {menuOpened} = props;
  const [, forceUpdate] = useReducer(x => x + 1, 0);
  const [selectedEdge, setSelectedEdge] = useState(0);

  const featureGroup = getEdgeFeatureGroup();
  const navItems = getEdgeFeatures(featureGroup);
  const miterEdgeFeature = getMiterEdgeFeature();

  const expanded = menuOpened === SIDEBAR_NAVIGATION_BUTTONS.edge;

  return (
    <div className={"content content--left side-level2" + (expanded ? " expanded" : "")} data-content="edge" id="edge-overlay">
      <div className="content-inner">
        <div className="lightbox-title-block">
          <span className="h7" data-text="sqft.navigation.edges.title">Select Edges</span>
          <p data-text="sqft.navigation.edges.description">Select an Edge and then click or touch the edges of the shape you want to have that edging.</p>
        </div>
        <div className="lightbox-button-block">
          <div className="lightbox-cancel-button">
            <FormattedMessage id="sqft.navigation.overlay.closeButton"/>
          </div>
        </div>
        <ul className="lightbox-options-wrapper" id="edge-overlay-items">
          {featureGroup && featureGroup.part && !featureGroup.part.allFeaturesReceived
            ? <AllFeaturesChecker subPart={featureGroup} callBack={() => forceUpdate(1)} loaderOnly={true}/>
            : navItems.map(navItem =>
              <SqftNavEdgesFeature
                selectedEdge={selectedEdge}
                setSelectedEdge={setSelectedEdge}
                edgeFeature={navItem.part}
                newWizardGroupId={navItem.newWizardGroupId}
                key={navItem.part.dbFeature.id}/>)}
          {
            miterEdgeFeature ? <SqftNavEdgesMiteredButton selectedEdge={selectedEdge}
                                     setSelectedEdge={setSelectedEdge}/>
              : ""
          }
        </ul>
        <div className="ui-loader"/>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {menuOpened} = store.sqftMenuState;
  const { refreshTick } = store.sqftMenuState || { refreshTick: 0 };
  return {
    menuOpened,
    refreshTick,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SqftNavEdges);
